import { AgGridReactProps } from '@ag-grid-community/react';
import { makeStyles } from '@mui/styles';
import { TransactionStatusCode, TransactionStatusCodeMap } from '@tassat/common-definitions';
import {
    AccountRecord, CollateralHistoryViewRecord, FirmRecord, UserAccountRecord, UserRecord, UserRole
} from '@tassat/fred-definitions';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface PledgeStatusCellRendererProps extends AgGridReactProps{
    value: number;
    data: CollateralHistoryViewRecord;
    currentUser: UserRecord;
    currentRole: UserRole;
    userAccount?: UserAccountRecord;
    pledgingFirm?: FirmRecord;
    pledgingAccount?: AccountRecord;
}

const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
    statusText: {
        whiteSpace: 'normal' as const,
        lineHeight: '18px'
    },
    reviewButton: {
        backgroundColor: '#EDCB26',
        padding: '.5rem .75rem',
        borderRadius: '3px',
        lineHeight: '18px'
    },
    failedButton: {
        backgroundColor: theme?.app?.applicationColors.failure ||
            '#FA5252',
        padding: '.5rem .75rem',
        borderRadius: '3px',
        lineHeight: '18px'
    },
    cancelButton: {
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLighter ||
            '#CFCFCF',
        border: `1px solid ${theme?.app?.applicationColors.enumColors.grey ||
        '#888888'}`,
        borderRadius: '3px',
        padding: '.5rem .75rem',
        color: theme?.app?.applicationColors.enumColors.black ||
            '#000',
        lineHeight: '18px'
    }
}));

export const PledgeStatusCellRenderer = (props: PledgeStatusCellRendererProps) => {
    const {
        value,
        data,
        currentUser,
        currentRole
    } = props;

    const classes = muiStyles(props);

    const showFailed = React.useMemo(() => {
        let failed = false;

        const canUserApproveFailed = currentUser.IsAdmin &&
            (currentRole.IsTransactionHistoryAllowed);

        if (data.Status === TransactionStatusCode.BANK_NO_ACK && canUserApproveFailed) {
            failed = true;
        }

        return failed;
    }, [ data, currentUser, currentRole ]);

    const displayValue = TransactionStatusCodeMap[value] ? TransactionStatusCodeMap[value].displayValue : 'Pending';

    return (
        <>
            {
                showFailed ?
                    <span className={classes.failedButton}>Failed</span>
                    : <span className={classes.statusText}>{displayValue}</span>
            }
        </>
    );
};

export default PledgeStatusCellRenderer;